import type { TipDistributionSummary } from '@/lib/api/timekeeping';

export const summarizePoolTotals = (
  summary: TipDistributionSummary | null,
): Array<{ poolName: string; amountCents: number }> => {
  if (!summary) {
    return [];
  }
  const totals = new Map<string, number>();
  for (const run of summary.runs) {
    const current = totals.get(run.poolName) ?? 0;
    totals.set(run.poolName, current + run.distributedTipCents);
  }
  return Array.from(totals.entries())
    .map(([poolName, amountCents]) => ({ poolName, amountCents }))
    .sort((a, b) => b.amountCents - a.amountCents);
};

